import React, { InputHTMLAttributes } from 'react';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  labelClasses?: string;
  money?: boolean;
  type: 'email' | 'number' | 'password' | 'tel' | 'text' | 'url';
}

const Input = ({ className, id, label, labelClasses, money, type, ...rest }: InputProps): JSX.Element => (
  <div className={`relative${className ? ` ${className}` : ''}`}>
    <input
      id={id}
      type={type}
      className={`${money !== undefined ? 'pl-4' : ''
      } peer mt-5 p-1 px-0.5 border-0 border-b-2 border-neutral-200 focus:ring-0 focus:border-sapphire w-full placeholder-transparent`}
      placeholder={label}
      {...rest}
    />
    {label && (
      <label
        htmlFor={id}
        className={`${money !== undefined ? 'peer-focus:left-0.5 peer-placeholder-shown:left-4' : ''
        } absolute left-0.5 top-0 peer-focus:top-0 peer-placeholder-shown:top-6 text-neutral-700 peer-focus:text-sapphire peer-placeholder-shown:text-neutral-400 text-sm peer-focus:text-sm peer-placeholder-shown:text-base pointer-events-none transition-all ${labelClasses ?? ''}`}
      >
        {label}
      </label>
    )}
    {money && (
      <span className='absolute left-0.5 top-6 text-neutral-700 peer-placeholder-shown:text-neutral-400 pointer-events-none'>
        $
      </span>
    )}
  </div>
);

const Radio = (props: InputHTMLAttributes<HTMLInputElement>): JSX.Element => {
  const { className, ...rest } = props;

  return (
    <input
      type='radio'
      className={`mb-2 border-solid border-gray-900 focus:ring-sapphire mt-1${className ? ` ${className}` : ''}`}
      {...rest}
    />
  );
}

export {
  Input, Radio
};
